import { escapeRegExp } from 'lodash-es';

export const replaceAll = (template: string, vars: Record<string, string | number>): string => {
    const regexVariable = Object.keys(vars).map((key) => escapeRegExp(`{{${key}}}`));
    const regex = new RegExp(regexVariable.join('|'), 'g');

    return template.replace(regex, (match) => {
        const formattedMatch = match.slice(2, -2);

        return vars[formattedMatch] as string;
    });
};
